import React from 'react';
import PropTypes from 'prop-types';
import { analyticsTrack } from '../../../analyticsUtils';
import './ProfileSuggestions.scss';

const redirectToProfile = (userPath, location) => {
  analyticsTrack('Clicked on Profile Suggestion Card button', { location });
  window.location.href = userPath;
};

function ProfileSuggestions({
  userPath, location, tagCategory, tags, small,
}) {
  if (small) {
    return (
      <div className="profile-suggestion-reminder-small body-text-3 demibold">
        <div className="row">
          <div className="col-md-2">
            <i className="fas fa-magic wand" />
          </div>
          <div className="col-md-10">
            <div className="cta-text">Review your Profile Suggestions</div>
            <div className="cta-subtext normal-weight">
              Add listed suggestions to improve your profile
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="profile-suggestion-reminder-card">
      <div className="cta row">
        <div className="col-md-10">
          <h2 className="cta-text mb-8">Review your profile suggestions!</h2>
        </div>
        <div className="col-md-2">
          <i className="fas fa-magic wand" />
        </div>
      </div>
      <div className="body-text-2">
        Clora listed profile recommendations to improve your profile.
      </div>
      <br />
      <div className="profile-suggestions body-text-2">
        <div className="heading">{tagCategory}</div>
        <div className="tags mb-2 mt-3 d-flex flex-wrap gap-2">
          {tags.map((t) => (
            <span key={t} className="badge small normal-font">{t}</span>
          ))}
        </div>
        <div className="row">
          <div className="md-4" />
          <div className="md-4 user-profile-link">
            {userPath
                && (
                <div>
                  <a
                    tabIndex={0}
                    role="button"
                    onClick={() => redirectToProfile(userPath, location)}
                  >
                    View All Profile Suggestions
                    {' '}
                  </a>
                  <i className="fas fa-angle-right" />
                </div>
                )}
          </div>
          <div className="md-4" />
        </div>
      </div>
    </div>
  );
}

ProfileSuggestions.propTypes = {
  userPath: PropTypes.string,
  location: PropTypes.string,
  tagCategory: PropTypes.string,
  tags: PropTypes.bool.isRequired,
  small: PropTypes.bool,
};

ProfileSuggestions.defaultProps = {
  userPath: null,
  location: '',
  small: false,
  tagCategory: '',
};

export default ProfileSuggestions;
